module.exports = __webpack_public_path__ + "img/ai.80ae6ba0.png";